import queryString, { ParsedQuery } from 'query-string';

interface Params {
    url?: string;
    query?: ParsedQuery;
    locale?: string;
    isFallbackLocale?: boolean;
}

function getLocaleUrlPart({ locale, isFallbackLocale }: Params) {
    return locale && !isFallbackLocale ? `/${locale}` : '';
}

export function getUrlWithLocale({ url = '', query = {}, locale, isFallbackLocale }: Params = {}) {
    const [path, search] = url.split('?');
    const pathWithSlash =
        path === '/'
            ? `${search ? `?${search}` : ''}`
            : `${!url || url.startsWith('/') ? url : `/${url}`}`;

    return queryString.stringifyUrl({
        url: `${getLocaleUrlPart({ locale, isFallbackLocale })}${pathWithSlash}` || '/',
        query,
    });
}
